// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  relationshipId: __t.u64().primaryKey().name("relationship_id"),
  sourceTwinId: __t.string().name("source_twin_id"),
  targetTwinId: __t.string().name("target_twin_id"),
  name: __t.string(),
  createdDateTime: __t.timestamp().name("created_date_time"),
});
